module.exports = {
    storeId: process.env.STORE_ID,
    apiUrl: process.env.API_URL,
    s3Bucket: process.env.S3_BUCKET,
    reactRoot: 'obsessvr-webstore-react-embed-root'
};
